// TODO: Update release notes link
export const CURRENT_RELEASE_NOTES =
  "https://trendmicro.atlassian.net/wiki/spaces/PBPIR/pages/601527737/v1.11.0+-+Monday+April+11+2024";

export const ALL_RELEASE_NOTES = `https://trendmicro.atlassian.net/wiki/spaces/PBPIR/pages/182991859/Release+Notes`;
